import React from 'react';
import { SvgProps } from '../core';

const FacebookLogo: React.FC<SvgProps> = ({
  width = 13,
  height = 24,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 13 24"
    >
      <path
        d="M12.5105 0.0049936L9.39235 0C5.88926 0 3.62541 2.31828 3.62541 5.90643V8.62969H0.490292C0.219381 8.62969 0 8.84891 0 9.11932V13.065C0 13.3354 0.219631 13.5544 0.490292 13.5544H3.62541V23.5106C3.62541 23.781 3.84479 24 4.1157 24H8.20614C8.47705 24 8.69643 23.7808 8.69643 23.5106V13.5544H12.3621C12.633 13.5544 12.8524 13.3354 12.8524 13.065L12.8539 9.11932C12.8539 8.98948 12.8021 8.86514 12.7103 8.77326C12.6185 8.68138 12.4934 8.62969 12.3634 8.62969H8.69643V6.32115C8.69643 5.21157 8.96134 4.64829 10.4095 4.64829L12.51 4.64755C12.7806 4.64755 13 4.42833 13 4.15817V0.494367C13 0.224462 12.7809 0.00549296 12.5105 0.0049936Z"
        fill="white"
      />
    </svg>
  );
};

export default FacebookLogo;
